<p-dialog
  header="Modifier Conséquence potentielle"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [styleClass]="'w-[90vw] max-w-[800px]'"
  (onHide)="onCancel()"
>
  <div class="p-0">
    <form [formGroup]="form">
      <div formArrayName="potentialConsequences" class="space-y-4">
        <div
          *ngFor="let actionGroup of formArray.controls; let i = index"
          [formGroupName]="i"
          class="flex items-start gap-4 mb-4 p-4 border border-slate-200 rounded-md"
          [ngClass]="{ 'opacity-50 pointer-events-none': !isVisibleRow(i) }"
          [style.display]="isVisibleRow(i) ? 'flex' : 'none'"
        >
          <div class="flex-1">
            <input
              type="text"
              pInputText
              formControlName="description"
              placeholder="Description de conséquence potentielle"
              class="w-full"
              [class.border-red-500]="
                actionGroup.get('description')?.invalid &&
                actionGroup.get('description')?.touched
              "
            />
            <small
              *ngIf="
                actionGroup.get('description')?.invalid &&
                actionGroup.get('description')?.touched
              "
              class="text-red-600 text-sm mt-1 block"
            >
              La description est requise
            </small>
          </div>

          <div class="flex items-center mt-1">
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-trash"
              class="p-button-danger p-button-sm p-button-outlined"
              (click)="deleteAt(i)"
            ></button>
          </div>
        </div>

        <div class="mt-4 text-center">
          <button
            type="button"
            pButton
            pRipple
            icon="pi pi-plus"
            label="Ajouter une conséquence potentielle"
            class="p-button-secondary p-button-outlined"
            (click)="addNew()"
          ></button>
        </div>
      </div>
    </form>

    <div
      *ngIf="!isFormValid"
      class="mt-4 p-4 bg-amber-100 border border-amber-200 rounded-md text-amber-800"
    >
      <div class="flex items-center gap-2">
        <i class="pi pi-exclamation-triangle text-amber-500"></i>
        <span>{{ validationMessage }}</span>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <button
        type="button"
        pButton
        pRipple
        label="Annuler"
        class="p-button-text"
        (click)="onCancel()"
      ></button>
      <button
        type="button"
        pButton
        pRipple
        label="Enregistrer"
        class="p-button-primary"
        (click)="onSubmit()"
        [disabled]="!isFormValid"
      ></button>
    </div>
  </div>
</p-dialog>
